import styled from 'styled-components';
import {Form} from 'antd';
import {InfoCircleOutlined} from '@ant-design/icons';
import AntdModal from '../../../AntdModal';
import {colorsStyles} from '../../../../utils/styles/colors.styles';

const StyledExportModal = styled(AntdModal)`
  .ant-picker {
    width: 100%;
  }
  .ant-space {
    text-align: center;
    width: 100%;
  }
`;

const StyledExportModalBlockedMessage = styled.div`
  padding-top: 24px;
`;

const StyledExportModalAccountItem = styled(Form.Item)`
  text-align: left;
`;

const StyledExportModalCheckboxItem = styled(Form.Item).attrs({
  preserve: false
})`
  margin-bottom: 0;
  text-align: left;
`;

const StyledExportModalInfoIcon = styled(InfoCircleOutlined)`
  margin-left: 8px;
  color: ${colorsStyles.neutral_7};
`;

export {
  StyledExportModal,
  StyledExportModalAccountItem,
  StyledExportModalBlockedMessage,
  StyledExportModalCheckboxItem,
  StyledExportModalInfoIcon,
}
